<template>
  <div>
    <div
      class="d-flex justify-between"
    >
      <div class="d-flex">
        <h4 class="text-black mt-50">
          <strong>
            Riwayat Perjalanan
          </strong>
        </h4>
        <img
          :src="shipingImage"
          class="w-16 mx-1"
        >
      </div>
      <img
        v-if="$route.name !== 'tiket-detail'"
        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/close-circle.svg"
        type="button"
        @click="$bvModal.hide('tracking-resi')"
      >
    </div>
    <b-row class="my-8 overflow-auto h-[50rem]">
      <b-col
        v-if="itemAwb.length > 0"
        cols="12"
      >
        <b-row
          v-for="(item, index) in itemAwb"
          :key="index"
          class="my-1"
        >
          <b-col
            cols="2"
            class="ml-1"
            style="text-align: -webkit-center"
          >
            <img
              :src="iconAwb(item)"
              alt="icon-shipping"
            >
            <div
              v-if="index !== itemAwb.length - 1"
              class="border-dashed border-2 border-[#FBA63C] d-inline-block h-100"
            />
          </b-col>
          <b-col
            cols="9"
            class="d-inline-block"
          >
            <div>{{ FULL_DATE_TIME(item.date) }}</div>
            <div
              v-if="item.status === 'Problem'"
              class="align-self-center"
            >
              <div class="text-danger font-semibold">
                Kendala Pengiriman
              </div>
              <div
                class="p-1 border-2 bordered-[#E2E2E2]"
              >
                <div class="font-bold my-[5px]">
                  {{ item.desc }}{{ expedition === 'NINJA' ? ', ' + item.code : '' }}
                </div>
                <div class="d-flex">
                  <img
                    src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/truck-remove.svg"
                    alt="truck-remove"
                  >
                  <div class="mx-1">
                    <span>
                      Keterangan dari ekspedisi : <span v-if="item.notes !== null">{{ item.notes }}</span> <span v-else>-</span>
                    </span><br>
                    <div
                      v-if="item.proof_images !== ''"
                      class="grid gap-2"
                      :class="$route.name !== 'tiket-detail' ? 'grid-cols-2 lg:grid-cols-4' : 'grid-cols-2 lg:grid-cols-3'"
                    >
                      <a
                        v-for="(img, idx) in item.proof_images"
                        :key="idx"
                        class="text-danger"
                        :href="img"
                        target="_blank"
                      >[Lihat Bukti {{ idx+1 }}]</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class=""
            >
              <div class="font-bold">
                {{ item.desc }}
              </div>
              <div v-if="item.send_wa === 1">
                <div
                  class="d-flex relative p-1 mx-1 border-2 bordered-[#E2E2E2] rounded w-50"
                >
                  <img
                    src="https://storage.googleapis.com/komerce/assets/svg/WA-Premium.svg"
                    alt="wa-premium"
                  >
                  <span
                    v-if="item.type === 'sending'"
                    class="my-auto ml-1"
                  >Pemberitahuan pemberangkatan telah terkirim ke WA Pelanggan</span>
                  <span
                    v-if="item.type === 'arrived'"
                    class="my-auto ml-1"
                  >Info paket COD hampir sampai telah terkirim ke WA Pelanggan</span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="itemAwb.length === 0">
        <div
          v-if="isLoading===false"
          class="d-block mt-5 mb-5 align-content-center text-center"
        >
          Data riwayat perjalan tidak ditemukan. <b>Bisa jadi</b> sudah request pickup/dijemput kurir saat pickup namun <b>belum discan</b> QR code untuk memulai perjalanan di kantor cabang. Harap menunggu
        </div>
        <div
          v-if="isLoading===true"
          class="d-block mt-5 mb-5 align-content-center text-center"
        >
          <div
            class="spinner-border text-primary"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </b-col>
    </b-row>

    <div v-if="isShowClaimMessage">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import { FULL_DATE_TIME } from '@/libs/filterDate'

export default {
  props: {
    awb: {
      type: String,
      default: '',
    },
    expedition: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      listAwb: '',
      itemAwb: [],
      shipingImage: '',
      FULL_DATE_TIME,
      isShowClaimMessage: false,
    }
  },
  async mounted() {
    await this.getHistoryPackage()
  },
  methods: {
    async getHistoryPackage() {
      const body = {
        awb: this.awb,
      }
      await this.$http_komship.post('/v1/admin/check-awb', body).then(res => {
        const { data } = res.data
        this.itemAwb = data.history
        this.shipingImage = data.shipping_icon
        this.isLoading = false
        this.isShowClaimMessage = data.is_lost_claimable
      }).catch(err => {
        this.isLoading = false
      })
    },
    iconAwb(items) {
      let result = ''
      if (items.status === 'Pickup') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-pickup.svg'
      } else if (items.status === 'Process') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-kirim.svg'
      } else if (items.status === 'Problem') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-problem.svg'
      } else if (items.status === 'Delivered') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-terima.svg'
      } else if (items.status === 'Retur') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-retur.svg'
      } else if (items.status === 'Delivery') {
        result = 'https://storage.googleapis.com/komerce/assets/icons/resi-delivery.svg'
      } else if (items.status === 'Canceled') {
        result = 'https://storage.googleapis.com/komerce/Komship/Status-resi.svg'
      }
      return result
    },
  },
}
</script>
